import { useState, useCallback, useMemo } from 'react';
import debounce from 'lodash/debounce';

interface User {
  id: string;
  email: string;
}

export const useUserFilter = (users: User[]) => {
  const [filterValue, setFilterValue] = useState('');
  const [filteredUsers, setFilteredUsers] = useState<User[]>(users);

  const debouncedFilter = useMemo(
    () =>
      debounce((searchTerm: string) => {
        const filtered = users.filter(user =>
          user.email.toLowerCase().includes(searchTerm.toLowerCase()),
        );
        setFilteredUsers(filtered);
      }, 300),
    [users],
  );

  const handleFilterChange = useCallback(
    (value: string) => {
      setFilterValue(value);
      if (value) {
        debouncedFilter(value);
      } else {
        setFilteredUsers(users);
      }
    },
    [users, debouncedFilter],
  );

  return {
    filterValue,
    filteredUsers,
    handleFilterChange,
  };
};
